import { useDispatch } from "react-redux";
import Dropdown from 'react-bootstrap/Dropdown';
import { Link, useNavigate } from "react-router-dom";
import NotesApi from '../api/NotesApi';
import { addSuccessMessage } from "../../../store/ActionAlertsStore";
import { FormattedMessage } from "react-intl";

type Props = {
    noteId:number
}

const NoteMenu = ({ noteId }: Props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const deleteNote = (e:any) => {
        e.preventDefault();
        NotesApi.deleteNote(noteId)
            .then(() => {
                dispatch(addSuccessMessage("Note deleted."))
                navigate("/notes");
            })
    } 

    return <>
        <Dropdown className="btn-group" bsPrefix="_no">
            <Dropdown.Toggle as="div" className="btn cur-p bgc-white no-after dropdown-toggle" >
                <i className="ti-more-alt"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu as="ul" className="fsz-sm">
                <Dropdown.Item as="li" bsPrefix="_no">
                    <Link to="#/" onClick={deleteNote} className="d-b td-n pY-5 pX-10 bgcH-grey-100 c-grey-700">
                        <i className="ti-trash mR-10"></i>
                        <span>
                            <FormattedMessage id="delete"/>
                        </span>
                    </Link>
                </Dropdown.Item>

                {/* <Dropdown.Item as="li" bsPrefix="_no">
                    <span className="d-b td-n pY-5 pX-10 bgcH-grey-100 c-grey-700">
                        <i className="ti-alert mR-10"></i>
                        <span>Mark as Spam</span>
                    </span>
                </Dropdown.Item> */}
            </Dropdown.Menu>
        </Dropdown>
    </>
}

export default NoteMenu;